<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import Select from "svelte-select";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import loadData from "../../utils/loadData";

  export let params;
  let uploading = false;
  let loading = true;

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let reorderLevel = null;
  let supplierID = null;
  let SKU = null;
  let lotNumber;
  let length;
  let width;
  let thickness;
  let bundlePrice;
  let class_;
  let totalMM;
  let plankNumber;

  // ------------
  let supplier;

  onMount(() => {
    axios
      .get(`${$config.backendURL}/items/${params.id}`)
      .then((res) => {
        name = res.data.name;
        price = res.data.price;
        inventoryLevel = res.data.inventoryLevel;
        reorderLevel = res.data.reorderLevel;
        supplierID = res.data.supplierID;
        SKU = res.data.SKU;
        lotNumber = res.data.lotNumber;
        length = res.data.length;
        width = res.data.width;
        thickness = res.data.thickness;
        bundlePrice = res.data.bundlePrice;
        class_ = res.data.class_;
        totalMM = res.data.totalMM;
        plankNumber = res.data.plankNumber;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    reorderLevel = null;
    SKU = null;
  };

  const handleSubmit = async (e) => {
    if (1 > 2) alert("... missing!");
    else {
      uploading = true;

      let data = {
        name,
        price,
        inventoryLevel,
        reorderLevel,
        supplierID: supplier?.value || supplierID,
        SKU,
        lotNumber,
        length,
        width,
        thickness,
        bundlePrice,
        totalMM: length * width * thickness,
        plankNumber,
      };

      axios
        .put(`${$config.backendURL}/items/${params.id}`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Updated Successfully`);
          loadData();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Edit Stock Item — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Edit Item"
    description="Fill out the form below to edit items. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="ml-3 btn btn-primary-outline" href="/#home">
      <i class="fas fa-arrow-left mr-3" />
      Return to Stock
    </a>
  </div>

  {#if loading}
    <div class="h-52 w-full flex items-center justify-center">
      <Wave size="50" color="rgb(244,162,97)" unit="px" />
    </div>
  {:else}
    <form
      on:submit|preventDefault={handleSubmit}
      class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <!-- here -->

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Stock Item Name :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={name}
            placeholder="Stock Item Name"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Quantity :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={inventoryLevel}
            placeholder="Quantity"
          />
        </div>
      </div>

      {#if /timber|foam|board|pine/.test(class_) == false}
        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>EOQ :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              type="number"
              step="any"
              bind:value={reorderLevel}
              placeholder="EOQ"
            />
          </div>
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Unit Price :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              bind:value={price}
              type="number"
              step="any"
              placeholder="Unit Price"
            />
          </div>
        </div>
      {/if}

      {#if /timber|foam|board|pine/.test(class_)}
        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Lot Number :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              bind:value={lotNumber}
              type="text"
              placeholder="Lot Number"
            />
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Length :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              type="number"
              step="any"
              bind:value={length}
              placeholder="Length"
            />
          </div>
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Width :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              bind:value={width}
              type="number"
              step="any"
              placeholder="Width"
            />
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Thickness :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              type="number"
              step="any"
              bind:value={thickness}
              placeholder="Thickness"
            />
          </div>
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Bundle Price :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              bind:value={bundlePrice}
              type="number"
              step="any"
              placeholder="Bundle Price"
            />
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Plank Number :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              bind:value={plankNumber}
              type="text"
              placeholder="Plank Number"
            />
          </div>
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>EOQ :</div>
            <input
              class="col-span-2 shadow-sm placeholder-gray-300"
              type="number"
              step="any"
              bind:value={reorderLevel}
              placeholder="EOQ"
            />
          </div>
        </div>
      {/if}

      {#if /timber|foam|board|pine/.test(class_) == false}
        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Current Supplier</div>
            <div class="col-span-2">
              {$config.suppliers.find(({ value }) => value == supplierID)?.label || "None"}
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
          <div class="grid grid-cols-3 gap-2 items-center">
            <div>Change Supplier</div>
            <div class="col-span-2">
              <Select
                items={$config.suppliers}
                on:select={(e) => (supplier = e.detail)}
              />
            </div>
          </div>
        </div>
      {/if}

      {#if uploading}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-primary-outline">
            <Wave size="25" color="rgb(244,162,97)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="grid grid-cols-2 gap-8">
          <button class="btn btn-primary-outline" on:click={handleClear}>
            <i class="fas fa-times-circle mr-3" />
            Clear Form
          </button>
          <button class="btn btn-primary">
            <i class="fas fa-check-circle mr-3" />
            Save to Database
          </button>
        </div>
      {/if}
    </form>
  {/if}
</Layout>
